module.exports = __webpack_public_path__ + "img/task.f5e1c7d8.png";